import { css } from "@linaria/core"
import { styled } from "@linaria/react"
import { useContext } from "react"

import { AgentMessageContainer } from "@/components/Chat/AgentMessageStyles.ts"
import { Vertical } from "@/components/Flex.ts"
import { CodeSnippetDialog } from "@/components/ReasoningStep/CodeSnippetDialog.tsx"
import { TaskViewModelContext } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"
import { ellipsize } from "@/styles/textStyles.ts"

import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"


export const RepositoryMirroringStatusMessage = (props: {
  content: AiChatMessageContent.InitProject.RepositoryMirroringStarted
  isActive: boolean
  isLast: boolean
}) => {
  const taskModel = useContext(TaskViewModelContext)

  let text: string
  if (props.content.error) {
    text = props.content.error
  } else if (props.content.projectKey) {
    if (props.content.progress) {
      text = ellipsize(`Mirroring the project: ${Math.min(Math.ceil(props.content.progress * 100), 100)}%`)
    } else {
      text = ellipsize("Mirroring the project")
    }
  } else {
    text = ellipsize("Checking connection")
  }

  return (
    <AgentMessageContainer isActive={props.isActive}>
      <CodeSnippetDialog
        execResultId={props.content.execResultId}
        taskId={taskModel?.taskId ?? null}
        title="Git Clone Log"
      >
        <Pill className={props.content.error ? Disabled : undefined}>
          <PillInner className={props.content.error ? Disabled : undefined}>
            {text}
          </PillInner>
          <PillBackground />
        </Pill>
      </CodeSnippetDialog>
    </AgentMessageContainer>
  )
}

const Disabled = css`
  animation: none !important;
`

const Pill = styled(Vertical)`
  position: relative;

  flex-shrink: 0;
  flex-grow: 0;
  justify-self: flex-start;
  min-height: 64px;

  border-radius: var(--border-radius-20);

  overflow: hidden;

  @keyframes sliding-reflection {
    0% {
      background-position: 100% 0;
    }

    100% {
      background-position: -100% 0;
    }
  }

  animation: sliding-reflection 2s ease-in-out infinite;
  background-image: linear-gradient(120deg, transparent 10%, var(--highlighted-text-color-30) 50%, transparent 90%);
  background-size: 200% 100%;
`

const PillBackground = styled(Vertical)`
  position: absolute;
  z-index: 0;
  inset: 0;
  background-color: var(--main-color-10);
`

const PillInner = styled(Vertical)`
  align-items: flex-start;
  justify-content: center;

  flex-grow: 1;

  gap: 4px;

  padding: 16px 24px;

  @keyframes sliding-reflection {
    0% {
      background-position: 100% 0;
    }

    100% {
      background-position: -100% 0;
    }
  }

  animation: sliding-reflection 2s ease-in-out infinite;
  background-image: linear-gradient(120deg, var(--main-color) 10%, var(--highlighted-text-color) 50%, var(--main-color) 90%);
  background-size: 200% 100%;
  background-clip: text;

  color: transparent;
`